var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-page"},[_c('div',{staticClass:"img-container"},[_c('app-image',{attrs:{"id":_vm.image}})],1),_c('div',{staticClass:"app-container"},[_c('div',{staticClass:"title"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }